import { render, staticRenderFns } from "./shipping-card.vue?vue&type=template&id=76aea9e2&scoped=true&"
import script from "./shipping-card.vue?vue&type=script&lang=js&"
export * from "./shipping-card.vue?vue&type=script&lang=js&"
import style0 from "./shipping-card.vue?vue&type=style&index=0&id=76aea9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aea9e2",
  null
  
)

export default component.exports